import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sp-card',
  standalone: false,
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']

})
export class CardComponent implements CardInterface, OnInit {
  @Input() spTitle = 'Button';
  @Input() sideTitle = null;
  @Input() tag = false;
  @Input() sideTag = {
    style: '',
    title: ''
  };
  @Input() action_title = '';
  @Input() type = '';
  @Input() style = '';
  @Input() status = '';
  @Input() action = null;
  @Input() collapsed = false;
  @Input() expandable = false;
  @Input() multiple_actions = null;
  @Input() footer;
  @Input() cardId = '';

  constructor() {}

  ngOnInit(): void {}

  expandCollapse() {
    this.collapsed = !this.collapsed;
  }
}

export interface CardInterface {
  spTitle?: string;
  sideTitle?: string;
  type?: string;
  footer?: Record<string, unknown>;
  action: Record<string, unknown>;
  tag?: boolean;
  collapsed?: boolean;
  expandable?: boolean;
  multiple_actions?: Record<string, unknown>;
  cardId?: string;
}